export default __webpack_public_path__ + "static/media/govuk-mask-icon.b3c94baf.svg";